import hash from 'object-hash'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import type { CarouselProps } from '@hcr/ui'
import { CardEmbedment, CardPromotion, CardVariant, Carousel, unit } from '@hcr/ui'
import { flow, isNotNull } from '@hcr/utils'

import { WarningMissingData } from '../../../../../../components/common'
import { LINK_CONFIG } from '../../../../../../configs'
import { useHoldingsQuery, useIdToken } from '../../../../../../hooks'
import { selectHoldingsWithNextWeeks } from '../../../../../../utils'
import { createHoldingPreview } from '../holding-preview'

import { HoldingsLoading } from './HoldingsLoading'

const holdingPreview = createHoldingPreview()

export const Holdings: FC = () => {
  const { t } = useTranslation()
  const idToken = useIdToken()

  const holdings = useHoldingsQuery(
    { idToken: String(idToken) },
    {
      select: flow(selectHoldingsWithNextWeeks),
      enabled: isNotNull(idToken),
      retryOnMount: false,
    }
  )

  if (holdings.isError) {
    return <WarningMissingData />
  }

  if (holdings.isSuccess) {
    const cardPromotion: CarouselProps['children'][number] = [
      hash([t('owner.cant-see-your-holding?')]),
      <CardPromotion
        key={hash([t('owner.cant-see-your-holding?')])}
        description={t('owner.registering-your-ownership-may-take-a-while')}
        embedment={CardEmbedment.Carousel}
        link={{
          isExternal: true,
          label: t('owner.more-information'),
          to: LINK_CONFIG.termsOfOwnership,
        }}
        title={t('owner.cant-see-your-holding?')}
        variant={CardVariant.Owner}
      />,
    ]

    return (
      <Carousel slidesMargin={unit(3)} title={t('owner.your-holdings')}>
        {holdings.data.map(holdingPreview).concat([cardPromotion])}
      </Carousel>
    )
  }

  return <HoldingsLoading />
}
